/* eslint-disable radix */
/* eslint-disable no-unused-expressions */
import React from "react";
import { useHistory } from "react-router-dom";
import { SendToast } from "@networkraildigitalfactory/components";
import styles from "./MyPerformanceContent.module.css";
import { CircleCheck, CircleDraft, CirclePlus } from "../TableIcons/TableIcons";

const TableView = (props) => {
  const { tableData, colHeadings, isLineManagerView, employeeEmail, financialYear } = props;

  // Calculate date to ensure user can create/edit/view interim or eoy within 6 months of the financial year
  const today = new Date();
  const financialYearEnd = parseInt(financialYear.split("-")[0]) + 1;
  const fyPlus3Months = new Date(financialYearEnd, 6, 6);

  const history = useHistory();

  const beginPrep = (year, type) => {
    history.push(
      isLineManagerView
        ? `/my-team/${employeeEmail}/view-review-prep/${year}/${type}`
        : `/new-review-prep/${year}/${type}`
    );
  };

  const editPrep = (year, type) => {
    history.push(
      isLineManagerView
        ? `/my-team/${employeeEmail}/view-review-prep/${year}/${type}`
        : `/edit-review-prep/${year}/${type}`
    );
  };

  const viewPrep = (year, type) => {
    history.push(
      isLineManagerView
        ? `/my-team/${employeeEmail}/view-review-prep/${year}/${type}`
        : `/view-review-prep/${year}/${type}`
    );
  };

  const interimPrepClicked = (item) => {
    const type = "Interim";
    const {
      FinancialYear,
      isInterimPrepStarted,
      isInterimPrepCompleted,
      isInterimCompleted,
      isEOYCompleted,
    } = item;

    // Convert itemFinancialYear and current financial year to ints in order to compare, if it is a past or present interm/eoy
    const yearTrue = FinancialYear === financialYear;

    const formattedItemFY = FinancialYear.replace("/", "-");

    if (
      !isInterimPrepStarted &&
      !isInterimCompleted &&
      !isEOYCompleted &&
      (yearTrue || today < fyPlus3Months)
    ) {
      beginPrep(formattedItemFY, type);
    } else if (
      isInterimPrepCompleted &&
      !isInterimCompleted &&
      !isEOYCompleted &&
      (yearTrue || today < fyPlus3Months)
    ) {
      viewPrep(formattedItemFY, type);
    } else if (
      isInterimPrepStarted &&
      !isInterimCompleted &&
      !isEOYCompleted &&
      (yearTrue || today < fyPlus3Months)
    ) {
      editPrep(formattedItemFY, type);
    } else if (
      isInterimPrepCompleted &&
      !isInterimCompleted &&
      isEOYCompleted &&
      (yearTrue || today < fyPlus3Months)
    ) {
      isLineManagerView ? viewPrep(formattedItemFY, type) : viewPrep(formattedItemFY, type);
      isLineManagerView
        ? SendToast("EOY Complete, cannot begin interim review", "error")
        : SendToast("EOY Complete, unable to edit your Interim Prep", "error");
    } else if (isInterimPrepCompleted && isEOYCompleted && (yearTrue || today < fyPlus3Months)) {
      isLineManagerView ? viewPrep(formattedItemFY, type) : viewPrep(formattedItemFY, type);
    } else if (
      (isInterimCompleted && isEOYCompleted && (yearTrue || today < fyPlus3Months)) ||
      (isInterimCompleted && !isEOYCompleted && (yearTrue || today < fyPlus3Months))
    ) {
      viewPrep(formattedItemFY, type);
    } else if (isEOYCompleted && (yearTrue || today < fyPlus3Months)) {
      isLineManagerView
        ? SendToast("EOY Complete, cannot begin interim review", "error")
        : SendToast("EOY Complete, cannot begin interim prep", "error");
    } else if (!yearTrue || today > fyPlus3Months) {
      SendToast("Financial year has passed unable to edit", "error");
      viewPrep(formattedItemFY, type);
    }
  };

  const eoyPrepClicked = (item) => {
    const type = "EOY";
    const { FinancialYear, isEOYPrepStarted, isEOYPrepCompleted, isEOYCompleted } = item;
    const formattedItemFY = FinancialYear.replace("/", "-");

    const yearTrue = FinancialYear === financialYear;
    if (
      !isEOYPrepStarted &&
      !isEOYPrepCompleted &&
      !isEOYCompleted &&
      (yearTrue || today < fyPlus3Months)
    ) {
      // new eoy prep
      beginPrep(formattedItemFY, type);
    } else if (
      isEOYPrepStarted &&
      !isEOYPrepCompleted &&
      !isEOYCompleted &&
      (yearTrue || today < fyPlus3Months)
    ) {
      // edit prep
      editPrep(formattedItemFY, type);
    } else if (
      (isEOYPrepCompleted && (yearTrue || today < fyPlus3Months)) ||
      (isEOYCompleted && (yearTrue || today < fyPlus3Months))
    ) {
      // read only view
      viewPrep(formattedItemFY, type);
    } else if (!yearTrue || today > fyPlus3Months) {
      SendToast("Financial year has passed unable to edit", "error");
      viewPrep(formattedItemFY, type);
    }
  };

  const renderTableHeader = () => {
    return colHeadings.map((heading, index) => {
      return (
        <th className={styles.header_item} key={index}>
          {heading}
        </th>
      );
    });
  };

  const renderTable = () => {
    let rowColor;
    return (
      tableData &&
      tableData.map((item, index) => {
        const {
          FinancialYear,
          isInterimPrepStarted,
          isInterimPrepCompleted,
          isInterimCompleted,
          isEOYPrepStarted,
          isEOYPrepCompleted,
          isEOYCompleted,
        } = item;

        if (
          !isInterimPrepCompleted ||
          !isInterimCompleted ||
          !isEOYPrepCompleted ||
          !isEOYCompleted
        ) {
          rowColor = false;
        } else {
          rowColor = true;
        }
        return (
          <tr
            id="tabToMe"
            name={index}
            tabIndex={0}
            key={index}
            className={!rowColor ? styles.row_fail : styles.row_success}
          >
            <td>Financial year {FinancialYear}</td>
            <td className={styles.activeCell} role="gridcell">
              <div
                name="interim prep"
                role="button"
                tabIndex={0}
                onClick={() => interimPrepClicked(item)}
                onKeyDown={(e) => (e.key === "Enter" ? interimPrepClicked(item) : undefined)}
              >
                {isInterimPrepCompleted && <CircleCheck />}
                {isInterimPrepStarted && !isInterimPrepCompleted && <CircleDraft />}
                {!isInterimPrepStarted && !isInterimPrepCompleted && <CirclePlus />}
              </div>
            </td>
            <td className={styles.activeCell} role="gridcell">
              <div
                name="is interim prep completed"
                role="button"
                tabIndex={0}
                onClick={() => interimPrepClicked(item)}
                onKeyDown={(e) => (e.key === "Enter" ? interimPrepClicked(item) : undefined)}
              >
                {isInterimCompleted && <CircleCheck />}
                {!isInterimCompleted && <CirclePlus />}
              </div>
            </td>
            <td className={styles.activeCell} role="gridcell">
              <div
                name="eoy prep"
                role="button"
                tabIndex={0}
                onClick={() => eoyPrepClicked(item)}
                onKeyDown={(e) => (e.key === "Enter" ? eoyPrepClicked(item) : undefined)}
              >
                {isEOYPrepCompleted && <CircleCheck />}
                {isEOYPrepStarted && !isEOYPrepCompleted && <CircleDraft />}
                {!isEOYPrepCompleted && !isEOYPrepStarted && <CirclePlus />}
              </div>
            </td>
            <td className={styles.activeCell} role="gridcell">
              <div
                name="is eoy prep completed"
                role="button"
                tabIndex={0}
                onClick={() => eoyPrepClicked(item)}
                onKeyDown={(e) => (e.key === "Enter" ? eoyPrepClicked(item) : undefined)}
              >
                {isEOYCompleted && <CircleCheck />}
                {!isEOYCompleted && <CirclePlus />}
              </div>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <table className={styles.TableView}>
      <thead>{tableData.length !== 0 ? <tr>{renderTableHeader()}</tr> : <></>}</thead>
      <tbody>{renderTable()}</tbody>
    </table>
  );
};
export default TableView;
